import * as React from 'react';
import * as _ from 'lodash';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store/types';
import { editLiveCategory, getEngineCategoryAPI, getLMCategoriesAPI, postLMCategoriesAPI } from './state/actions';
import { SectionWrapper } from 'common/baseComponents';
import { ReactComponent as IconCategories } from 'common/images/icon-categories.svg'
import { GeneralContainer, Title, IconContainer } from './styles';
import InputIconField, { InputIconFieldAction, InputIconFieldState } from 'components/InputIcon';
import { serviceLoading } from 'common/loaderReducer';
import { GET_LMCATEGORIES_API_REQUEST, POST_LMCATEGORIES_API_REQUEST } from 'features/Dealers/Listings/Categories/state/actionTypes';
import Alert from 'features/Dealers/Listings/Categories/Alert';
import ViewUICategories from 'features/Dealers/Listings/Categories/ViewCategories';
import HoverableSuggestions from 'features/Dealers/Listings/Categories/HoverableSuggestions';
import EditCategories from 'features/Dealers/Listings/Categories/EditCategories';
import Loader from 'components/Loader';
import { ListingSyncErrorsUI } from 'features/Dealers/Listings/state/types';
import { getListingSyncErrors } from 'features/Dealers/Listings/state/actions';
import { getDealerListingsWithErrors } from 'features/Dealers/Listings/state/actions';
import { getSyncError } from 'features/Dealers/Listings/utils'


const LMCategories = () => {
    const dispatch = useDispatch();
    const [firstLoad, setFirstLoad] = React.useState(true)

    const [editingState, setEditingState] = React.useState(InputIconFieldState.VIEW);

    const {
        isLoading,
        categories,
        liveCategories,
        isSaving,
        recommendedCategories,
        dealerId,
        listingSyncErrors,
        selectedDealerId,
        selectedListingId,
        countryData,
        showRecommended,
        industry,
    } = useSelector((rootState: RootState) => {
        return {
            isLoading: serviceLoading(rootState, [GET_LMCATEGORIES_API_REQUEST]),
            isSaving: serviceLoading(rootState, [POST_LMCATEGORIES_API_REQUEST]),
            recommendedCategories: rootState.dealers.listing.currentListing.categories.recommendedDealerCategories,
            liveCategories: rootState.dealers.listing.currentListing.categories.liveDealerCategories,
            categories: rootState.dealers.listing.currentListing.categories.originalDealerCategories,
            allCategories: rootState.dealers.listing.currentListing.categories.enginecategories,
            dealerId: rootState.dealers.dealer.selectedDealer?.id,
            listingSyncErrors: rootState.dealers.listing.listings.listingSyncErrors,
            selectedDealerId: rootState.dealers.dealer.selectedDealer?.id,
            selectedListingId: rootState.dealers.listing.listings.selectedListingId,
            countryData: rootState.dealers.enginedealer.countryData,
            showRecommended: rootState.dealers.listing.currentListing.categories.showRecommended,
            industry: rootState.dealers.dealer.industry
        }
    }, shallowEqual);

    React.useEffect(() => {
        if (selectedListingId && selectedListingId != "") {
            dispatch(getLMCategoriesAPI(selectedListingId))
        }
    }, [selectedListingId])

    React.useEffect(() => {        
        dispatch(getEngineCategoryAPI("GMB", countryData?.countryCode ?? "", countryData?.languageCode??"en-US", 0, undefined, undefined)); //English is Default
    }, []);

    React.useEffect(() => {
        if (!firstLoad && !isSaving && selectedListingId && selectedListingId != "" && selectedDealerId) {
            dispatch(getListingSyncErrors(selectedListingId??""));
            dispatch(getDealerListingsWithErrors(selectedDealerId??""));
        }
        setFirstLoad(false);
    }, [isSaving]) 

    if (isLoading || !selectedListingId || selectedListingId == "") {
        return <Loader />
    }

    return (
        <GeneralContainer>
            <SectionWrapper>
                <InputIconField
                    label={'Categories'}
                    state={isSaving ? InputIconFieldState.LOADING : editingState}
                    renderValue={renderCategories}
                    renderIcon={() => { return (<IconContainer><IconCategories /></IconContainer>) }}
                    showAlertIcon={getSyncError('categories',listingSyncErrors)?true:false}
                    alertToolTip={getSyncError('categories',listingSyncErrors)}
                    showEditErrorMessage={getSyncError('categories',listingSyncErrors)?true:false}
                    editErrorMessage={getSyncError('categories',listingSyncErrors)}
                    onActionClick={(action: InputIconFieldAction) => { onFieldActionClick(action) }}
                    disabled={false}
                    disableBackground={true}
                />
            </SectionWrapper>
        </GeneralContainer>
    )

    function onFieldActionClick(action: InputIconFieldAction) {
        switch (action) {
            case InputIconFieldAction.SAVE:
                {
                    setEditingState(InputIconFieldState.VIEW)
                    dispatch(postLMCategoriesAPI(selectedListingId ?? "", "GMB", dealerId, liveCategories))
                    break;
                }
            case InputIconFieldAction.EDIT:
                {
                    setEditingState(InputIconFieldState.EDIT)
                    break;
                }
            case InputIconFieldAction.CANCEL:
                {
                    setEditingState(InputIconFieldState.VIEW)
                    dispatch(editLiveCategory(categories))
                }
        }
    }

    function renderCategories() {

        if (editingState === InputIconFieldState.VIEW || editingState === InputIconFieldState.LOADING) {
            if (liveCategories) {
                return (
                    <ViewUICategories
                        categories={liveCategories}
                    />
                )
            } else if (recommendedCategories) {
                return (
                    <>
                        <Alert
                            title={"We have applied a recommended list for you."}
                            subtitle={"Categories are very important as they describe your business both to people and search engines."}
                        />
                        <ViewUICategories
                            categories={recommendedCategories}
                        />
                    </>
                )
            }
        } else if (editingState === InputIconFieldState.EDIT && (liveCategories || recommendedCategories)) {
            let editableCategories = liveCategories ? _.cloneDeep(liveCategories) : _.cloneDeep(recommendedCategories);
            return (
                <>
                    {
                        recommendedCategories &&  showRecommended &&
                        <HoverableSuggestions
                            categories={recommendedCategories}
                            onRecommendationsClick={() => onCategoriesChange(_.cloneDeep(recommendedCategories))}
                        />
                    }
                    <EditCategories
                        categories={(editableCategories) as any}
                        onCategoriesChange={onCategoriesChange} />
                </>
            )
        }
    }

    function onCategoriesChange(c) {
        dispatch(editLiveCategory(c));
    }
}

export default LMCategories

